import { CardBody, Form, FormGroup, Input, Label, TabContent, TabPane } from "reactstrap";
import { TabDatatype } from "../../../../Types/UiKitsType";
import { H4, P } from "../../../../AbstractElements";
import { useEffect, useState } from "react";
import { ColumnDefinition, ensureDexieReady, getDataFromDexie } from "../../../../db/DexieServises";
import { TableData } from "../../../Tables/ReactstrapTables/BasicTables/HoverableRows/DynamicDataTable";
import DynamicTable from "../../../../db/DynamicTable";
import { API } from "../../../../api/API";
import { getData } from "../../../../CommonElements/Functions/PostGetFun";
import { toast } from "react-toastify";
import CommonTableNew from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";

export default function BorderTabContent({ tabId, employeeIdProp }: { tabId: string, employeeIdProp: number }) {
    const [allTables, setAllTables] = useState([]);
    const [logTabs, setLogtab] = useState([]);
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    useEffect(() => {
        const tableName = "UserSession";
        const loadAllTables = async () => {
            if (!serverUrl || !APP_TOKEN) {
                console.error('❌ Missing server URL or app token');
                return;
            }
            const url = `${serverUrl}${API.getUserSessions}`;
            const { status, data } = await getData(url, true, {
                employee_id: employeeIdProp,

            });
            if (status === 200) {

                setAllTables(data?.data);
            } else {
                toast.error(data.message)
            }
        };

        loadAllTables();
    }, []);
    useEffect(() => {
        const tableName = "UserLogs";

        const loadAllTables = async () => {
            if (!serverUrl || !APP_TOKEN) {
                console.error('❌ Missing server URL or app token');
                return;
            }
            const url = `${serverUrl}${API.getUserLogs}`;
            const { status, data } = await getData(url, true, {
                employee_id: employeeIdProp,

            });
            if (status === 200) {

                setLogtab(data?.data);
            } else {
                toast.error(data.message)
            }
        };

        loadAllTables();
    }, []);
    const keys = allTables.length > 0 ? Object.keys(allTables[0]) : [];
    const headData = keys.map((key, index) => ({
        id: `${index + 1}`,
        head: key,  // Optional: Make header labels more readable
        key: key,
        sortKey: key             // You can set this to `null` if sorting isn't needed
    }));
    const keys1 = logTabs.length > 0 ? Object.keys(logTabs[0]) : [];
    const headData1 = keys1.map((key, index) => ({
        id: `${index + 1}`,
        head: key,  // Optional: Make header labels more readable
        key: key,
        sortKey: key             // You can set this to `null` if sorting isn't needed
    }));

    const firstTable = allTables[0];
    const logTable = logTabs[0];

    const borderData: TabDatatype[] = [
        {
            id: "1",
            text: <CommonTableNew
                caption=""
                headData={headData}
                data={allTables}
                // rowsPerPage={10}
                renderRow={(row, rowIndex) => (
                    <tr key={rowIndex}>
                        {keys.map((key, colIndex) => (
                            <td key={colIndex}>{(row as Record<string, any>)[key]}</td>
                        ))}
                    </tr>
                )}></CommonTableNew>
        },

        {
            id: "2",
            text: <CommonTableNew
                caption=""
                headData={headData1}
                data={logTabs}
                // rowsPerPage={10}
                renderRow={(row, rowIndex) => (
                    <tr key={rowIndex}>
                        {keys1.map((key, colIndex) => (
                            <td key={colIndex}>{(row as Record<string, any>)[key]}</td>
                        ))}
                    </tr>
                )}></CommonTableNew>
        },
        {
            id: "3",
            text: (
                <CardBody className="px-0 pb-0">
                    <Form>
                        <FormGroup>
                            <Label htmlFor="exampleFormControlInput1">Email address</Label>
                            <Input id="exampleFormControlInput1" type="email" placeholder="youremail@gmail.com" />
                        </FormGroup>
                    </Form>
                </CardBody>
            ),
        },
    ];

    return (
        <TabContent activeTab={tabId}>
            {borderData.map((item, index) => (
                <TabPane className={`fade ${tabId === item.id ? "show" : ""}`} tabId={item.id} key={index}>
                    {item.text}
                </TabPane>
            ))}
        </TabContent>
    );
}
